import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { useDishFeedsByAnalyzer } from 'features/dishes/api/getDishFeedsByAnalyzer';

interface Props {
  analyzerId: number;
  selectedPort: number;
  numberOfPorts: number | undefined;
  error?: boolean;
  helperText?: React.ReactNode | undefined;
  disabled?: boolean;
  onChange: (
    event: SelectChangeEvent<number>,
    child: React.ReactNode
  ) => void | undefined;
}

const AnalyzerPortWithLabelSelector = ({
  analyzerId,
  selectedPort,
  numberOfPorts,
  error,
  helperText,
  disabled,
  onChange,
}: Props) => {
  const { data: dishFeeds } = useDishFeedsByAnalyzer({ analyzerId });
  const portArray = Array.from(Array(numberOfPorts || 32), (_, i) => i + 1);

  const portsWithLabels = dishFeeds?.reduce(
    (
      data: {
        [id: string]: string;
      },
      feed
    ) => {
      if (!feed?.port) return data;
      data[feed.port.toString()] = feed.feed_name || feed.port.toString();
      return data;
    },
    {}
  );

  return (
    <>
      <FormControl fullWidth size='small'>
        <InputLabel id='port-label'>Port</InputLabel>
        <Select
          labelId='port-label'
          id='port'
          name='port'
          label='Port'
          value={selectedPort}
          disabled={disabled}
          required
          fullWidth
          error={error}
          onChange={onChange}
        >
          {portArray.map((port) => (
            <MenuItem value={port} key={port}>
              {!disabled && portsWithLabels && portsWithLabels[port]
                ? `${portsWithLabels[port].toString()} (${port.toString()})`
                : port.toString()}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>{helperText}</FormHelperText>
      </FormControl>
    </>
  );
};

export default AnalyzerPortWithLabelSelector;
